var _style, _defs, _use, _use2, _use3, _use4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimatedLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "131.308 115.876 381.355 423.182",
    width: 372.86,
    height: 412.18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    path {\n      stroke-dasharray: 800;\n      animation: draw 1.5s linear infinite;\n    }\n\n    @keyframes draw {\n      from {\n        stroke-dashoffset: 0\n      }\n      to {\n        stroke-dashoffset: 1600;\n      }\n    }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.19 428.02C471.58 447.6 410.52 482.78 320 533.56L136.81 428.02v-204.1l176.72-102.54 189.66 102.54",
    id: "a"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 0,
    to: 1600,
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320 533.56V319l-183.19-96.07",
    id: "c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 0,
    to: 1600,
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M503.19 430.01V223.92L320 320",
    id: "d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 0,
    to: 1600,
    dur: "1.5s",
    repeatCount: "indefinite"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fillOpacity: 0,
    stroke: "#7C7676",
    strokeWidth: 11
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fillOpacity: 0,
    stroke: "#7C7676",
    strokeWidth: 2
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fillOpacity: 0,
    stroke: "#7C7676",
    strokeWidth: 2
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fillOpacity: 0,
    stroke: "#7C7676",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedLogo);
export default __webpack_public_path__ + "static/media/AnimatedLogo.36a53e6ffa84e41ec71a45d4a2f0eb92.svg";
export { ForwardRef as ReactComponent };